export function listToTree(list, config = {}) {
    const ID_FIELD = config.id || "id";
    const PARENT_FIELD = config.parent || "parent";
    const CHILDREN_FIELD = config.children || "children";

    const hashTable = Object.create(null);

    list.forEach((listItem) => {
        const id = listItem[ID_FIELD];
        hashTable[id] = {
            ...listItem,
            [CHILDREN_FIELD]: [],
        };
    });

    const tree = [];

    list.forEach((listItem) => {
        const id = listItem[ID_FIELD];
        const parentId = listItem[PARENT_FIELD];
        const treeItem = hashTable[id];

        if (parentId) {
            hashTable[parentId][CHILDREN_FIELD].push(treeItem);
        } else {
            tree.push(treeItem);
        }
    });

    return tree;
}
